export const isMacOs = window.navigator.platform.match(/^Mac/)
const cmdOrCtrl = isMacOs ? 'cmd' : 'ctrl'
const altOrCtrl = isMacOs ? 'ctrl' : 'alt'
const altOrCtrlLabel = isMacOs ? 'Ctrl' : 'Alt'
export const keyboardShortcuts = {
   taskSearch: '/',
   toggleSidebar1: 'ctrl+b',
   toggleSidebar2: 'ctrl+B',
   gotoTask1: 'g',
   gotoTask2: 'G',
   nextTab1: 'n',
   preTab1: 'p',
   refresh1: 'r',
   refresh2: 'R',
   nextTask: 'ArrowRight',
   prevTask: 'ArrowLeft',
   changeView1: 'v',
   changeView2: 'V',
   toggleShortcutsPopOver: 'shift+/',
   createGoal1: `${altOrCtrl}+g`,
   createGoal2: `${altOrCtrl}+G`,
   editGoal: 'alt+u',
   openGlobalSearch1: `${cmdOrCtrl}+k`,
   openGlobalSearch2: `${cmdOrCtrl}+K`,
   quickCreateTask: 'tab+t',
   quickCreateOutcome: 'tab+o',
   quickCreateGoal: 'tab+g',
   openSearch: 'ctrl+k',
   createTask1: `${altOrCtrl}+t`,
   createTask2: `${altOrCtrl}+T`,
   createOutcome1: `${altOrCtrl}+o`,
   createOutcome2: `${altOrCtrl}+O`,
   createIdeationPage1: `${altOrCtrl}+i`,
   createIdeationPage2: `${altOrCtrl}+I`,
   createSpace1: `${altOrCtrl}+s`,
   createSpace2: `${altOrCtrl}+S`,
   undo: `${cmdOrCtrl}+z`
}

export const quickCreateShortCuts = {
   task: {
      primaryLabel: `${altOrCtrlLabel}`,
      secondaryLabel: 'T'
   },
   outcome: {
      primaryLabel: `${altOrCtrlLabel}`,
      secondaryLabel: 'O'
   },
   goal: {
      primaryLabel: `${altOrCtrlLabel}`,
      secondaryLabel: 'G'
   },
   ideation: {
      primaryLabel: `${altOrCtrlLabel}`,
      secondaryLabel: 'I'
   },
   spaces: {
      primaryLabel: `${altOrCtrlLabel}`,
      secondaryLabel: 'S'
   }
}
